import { useTranslation } from 'react-i18next';
import LinkWithQuery from '../components/LinkWithQuery';

import logo from '../assets/logo.png';

const HomePage = () => {
    const { t } = useTranslation();

    return (
        <div className="fixed w-full h-full flex justify-center items-center">
            <div>
                <img
                    src={logo}
                    rel="preload"
                    alt="HippoCare Logo"
                    className="w-96 md:w-1/2 m-auto"
                />

                <div className="text-center mt-8 lg:mt-12">
                    <LinkWithQuery to="/language">
                        <button className="mt-4 py-4 px-16 border rounded-xl bg-blue-600 text-white transition-shadow hover:ring-2 ring-sky-700">
                            {t('pages.home.start-button')}
                        </button>
                    </LinkWithQuery>
                </div>
            </div>
        </div>
    );
};

export default HomePage;
